import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import MultiRecordLayout from "./MultiRecordLayout";
import {
  getVendorInformation,
  checkChgVendorAvailability,
  updateVendorInformation,
  getWhseList,
  batchUpdateVendorInformation,
  batchReadVendorInformation
} from "../../../actions";
import Sanckbar from "../../common/Sanckbar";
import Spinner from "../../common/Spinner";
import StatusModal from "../../common/StatusModal";
import Tooltip from "../../common/Tooltip";
import UploadButtonVendorInfo from "../../../extension/components/UploadButtonVendorInfo/UploadButtonVendorInfo";
import BatchErrorModal from "./BatchErrorModal";

class ManageItemVendorInformationByDc extends React.Component {
  state = {
    notificationMsg: { text: "", color: "", icon: "" },
    isSaveEnabled: false,
    isNotificationOpened: false,
    modalButton1ActionParams: [],
    isMultiRecordMode: false,
    uploadedRecords: [],
    currentProcessing: 0,
    totalToProcess: 0,
    isLoadingRecords: false,
    warehouseList: [],
    isLoadingWhseList: true,
    showBatchErrorModal: false,
    failedRecords: [],
    failedRecordsTotalCount: 0,
    batchErrorSource: null
  };
  constructor() {
    super();
    this.headerData1 = [];
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = {};
    this.newInfo = {};
    this.dcReminderTimer = null;
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);

    this.setNotification("Loading DCs, please wait...", "#1e90ff", "hourglass_empty");

    getWhseList().then(res => {
      if (res && res.data && res.data.whses) {
        this.setState({ warehouseList: res.data.whses, isLoadingWhseList: false });
        this.setNotification();
        this.startDcReminderTimer();
      }
    }).catch(err => {
      console.warn('Could not preload warehouse list:', err.response?.status, err.response?.statusText, err.message);
      this.setState({ isLoadingWhseList: false });
      this.setNotification();
    });
  }
  startDcReminderTimer = () => {
    clearTimeout(this.dcReminderTimer);
    this.dcReminderTimer = setTimeout(() => {
      if (!this.state.isMultiRecordMode && !this.state.data) {
        this.setWarningMessage("Please select an item number and a warehouse");
      }
    }, 5000);
  };
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  formatHttpError = (err) => {
    if (err && err.response && err.response.status) {
      const status = err.response.status;
      const backendDetail = err.response.data?.messages?.[0]?.text
        || err.response.data?.message
        || '';

      switch (status) {
        case 400:
          return `Bad request: ${backendDetail || 'the server could not process the request'}`;
        case 401:
          return 'Session expired, please login again';
        case 403:
          return 'Access denied: you do not have permission for this action';
        case 404:
          return `Not found: ${backendDetail || 'the requested resource does not exist'}`;
        case 408:
          return 'Request timed out, please try again';
        case 429:
          return 'Too many requests, please wait a moment and try again';
        case 500:
          return `Internal server error: ${backendDetail || 'an unexpected problem occurred on the server'}`;
        case 502:
          return 'Bad gateway: the server is temporarily unavailable, please try again later';
        case 503:
          return 'Service unavailable: the server is under maintenance, please try again later';
        case 504:
          return 'Gateway timeout: the server took too long to respond, please try again';
        default:
          return `HTTP ${status}: ${backendDetail || err.response.statusText || 'unexpected error'}`;
      }
    }
    if (err && err.message === 'Network Error' && !err.response) {
      return 'Unable to reach the server: blocked by CORS policy or the server is not responding';
    }
    if (err && err.message) {
      return `Connection error: ${err.message}`;
    }
    return 'Unable to reach the server: blocked by CORS policy or the server is not responding';
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({
        notificationMsg: { text, color, icon },
        isNotificationOpened: true
      });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };

  modifyVendor = (id, whse, id2, whseName, isValid, tagName, stateId) => {
    var injectedValues = this.state.header;
    for (let i = 0; i < injectedValues.length; i++) {
      if (injectedValues[i].name === id) {
        injectedValues[i].injectedValue = whse;
        injectedValues[i].label = (
          <div className="with-tooltip">
            <i
              className="material-icons"
              style={isValid ? { color: "green" } : { color: "red" }}
            >
              {isValid ? "check" : "cancel"}
            </i>
            <Tooltip
              msg={isValid ? "Valid Vendor For This Warehouse" : whseName}
            />
            {tagName}
          </div>
        );
      }
      if (injectedValues[i].name === id2) {
        injectedValues[i].injectedValue = whseName;
      }
    }
    this.setState({ header: injectedValues });
    this.newInfo[stateId] = whse;
    this.checkHotChanges();
  };

  lookup = msg => {
    clearTimeout(this.dcReminderTimer);
    this.setNotification("Loading...", "#1e90ff", "hourglass_empty");
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = parseInt(this.state.lookup.item, 10).toString();
      getVendorInformation(item, this.state.lookup.wse).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        if (res.data.success) {
          this.newInfo = {};
          const data = res.data.data;
          // const whsesForItem = res.data.data.whsesForItem;
          // delete data.whsesForItem;
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Item",
                value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "item"
              },
              {
                label: "Description",
                value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                value: res.data.data.lineCode,
                name: "line"
              },
              {
                label: "Part",
                value: res.data.data.partNumber,
                name: "part"
              },
              {
                label: "Warehouses",
               // value: whsesForItem,
                name: "wse"
              },
              {
                label: "Vendor",
                value: res.data.data.vend,
                name: "vendor"
              },
              {
                label: "Vendor Name",
                value: res.data.data.hostVendorName,
                name: "vendorName"
              },
              {
                label: "Core Return",
                value: res.data.data.coreReturnVendor,
                name: "coreReturn"
              },
              {
                label: "Vendor Name",
                value: res.data.data.coreReturnVendorName,
                name: "vendorName2"
              },
              {
                label: "Recall",
                value: res.data.data.recallVendor,
                name: "recall"
              },
              {
                label: "Vendor Name",
                value: res.data.data.recallVendorName,
                name: "vendorName3"
              },
              {
                label: "Warranty",
                value: res.data.data.warrantyVendor,
                name: "warranty"
              },
              {
                label: "Vendor Name",
                value: res.data.data.warrantyVendorName,
                name: "vendorName4"
              },
              {
                label: "Next PO Cost",
                value: res.data.data.nipoBaseCost,
                name: "nextPOCost"
              },
              {
                label: "Core",
                value: res.data.data.nipoCoreCost,
                name: "core"
              },
              {
                label: "NIPO Maintenance Date",
                value: res.data.data.nipoMaintDate,
                name: "NPOMaintenanceDate"
              },
              {
                label: "Setup Date",
                value: res.data.data.setupDate,
                name: "setupDate"
              },
              {
                label: "Change Date",
                value: res.data.data.changeDate,
                name: "changeDate"
              }
            ],

            cards: [
              // cards
              {
                Dimensions: [
                  {
                    label: "Cubic Feet",
                    value: res.data.data.cubicFeet,
                    name: "cubicFeet"
                  },
                  {
                    label: "Cases Per Tier",
                    value: res.data.data.unitsPerTier,
                    name: "casesPerTier"
                  },
                  {
                    label: "Units Per Case",
                    value: res.data.data.unitsPerCase,
                    name: "unitsPerCase"
                  },
                  {
                    label: "Tiers Per Pallet",
                    value: res.data.data.tiersPerPallet,
                    name: "tiersPerPallet"
                  }
                ]
              },
              {
                "INFOREM Info": [
                  {
                    label: "Profile ID",
                    value: res.data.data.infPtag,
                    name: "profileID"
                  },
                  {
                    label: "DSER",
                    value: res.data.data.infDser,
                    name: "DSER"
                  },
                  {
                    label: "Profile Year",
                    value: res.data.data.infPtagYear,
                    name: "profileYear"
                  },
                  {
                    label: "Init DESEAS Demand",
                    value: res.data.data.infDDI,
                    name: "initDESEASDemand"
                  }
                ]
              },
              {
                "Vendor Conversion": [
                  {
                    label: "Factor",
                    value: res.data.data.vendConvFactor,
                    name: "factor"
                  },
                  {
                    label: "Action (* OR /)",
                    value: res.data.data.vendConvAction,
                    name: "action"
                  },
                  {
                    label: "Company POQ Multiple",
                    value: res.data.data.companyPoqMult,
                    name: "companyPOQMultiple"
                  }
                ]
              }
            ]
          });
        } else {
          this.setState({
            header: [
              {
                label: "Item",
                // value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "item"
              },
              {
                label: "Description",
                // value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                // value: res.data.data.lineCode,
                name: "line"
              },
              {
                label: "Part",
                // value: res.data.data.partNumber,
                name: "part"
              },
              {
                label: "Warehouses",
                // value: whsesForItem,
                name: "wse"
              },
              {
                label: "Vendor",
                // value: res.data.data.vend,
                name: "vendor"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.hostVendorName,
                name: "vendorName"
              },
              {
                label: "Core Return",
                // value: res.data.data.coreReturnVendor,
                name: "coreReturn"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.coreReturnVendorName,
                name: "vendorName2"
              },
              {
                label: "Recall",
                // value: res.data.data.recallVendor,
                name: "recall"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.recallVendorName,
                name: "vendorName3"
              },
              {
                label: "Warranty",
                // value: res.data.data.warrantyVendor,
                name: "warranty"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.warrantyVendorName,
                name: "vendorName4"
              },
              {
                label: "Next PO Cost",
                // value: res.data.data.nipoBaseCost,
                name: "nextPOCost"
              },
              {
                label: "Core",
                // value: res.data.data.nipoCoreCost,
                name: "core"
              },
              {
                label: "NIPO Maintenance Date",
                // value: res.data.data.nipoMaintDate,
                name: "NPOMaintenanceDate"
              },
              {
                label: "Setup Date",
                // value: res.data.data.setupDate,
                name: "setupDate"
              },
              {
                label: "Change Date",
                // value: res.data.data.changeDate,
                name: "changeDate"
              }
            ],

            cards: [
              // cards
              {
                Dimensions: [
                  {
                    label: "Cubic Feet",
                    // value: res.data.data.cubicFeet,
                    name: "cubicFeet"
                  },
                  {
                    label: "Cases Per Tier",
                    // value: res.data.data.unitsPerTier,
                    name: "casesPerTier"
                  },
                  {
                    label: "Units Per Case",
                    // value: res.data.data.unitsPerCase,
                    name: "unitsPerCase"
                  },
                  {
                    label: "Tiers Per Pallet",
                    // value: res.data.data.tiersPerPallet,
                    name: "tiersPerPallet"
                  }
                ]
              },
              {
                "INFOREM Info": [
                  {
                    label: "Profile ID",
                    // value: res.data.data.infPtag,
                    name: "profileID"
                  },
                  {
                    label: "DSER",
                    // value: res.data.data.infDser,
                    name: "DSER"
                  },
                  {
                    label: "Profile Year",
                    // value: res.data.data.infPtagYear,
                    name: "profileYear"
                  },
                  {
                    label: "Init DESEAS Demand",
                    // value: res.data.data.infDDI,
                    name: "initDESEASDemand"
                  }
                ]
              },
              {
                "Vendor Conversion": [
                  {
                    label: "Factor",
                    // value: res.data.data.vendConvFactor,
                    name: "factor"
                  },
                  {
                    label: "Action (* OR /)",
                    // value: res.data.data.vendConvAction,
                    name: "action"
                  },
                  {
                    label: "Company POQ Multiple",
                    // value: res.data.data.companyPoqMult,
                    name: "companyPOQMultiple"
                  }
                ]
              }
            ]
          });
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        this.setErrorMessage(this.formatHttpError(err));
      });
    } else {
      if (!this.state.isLoadingWhseList) {
        this.setErrorMessage("Please select an item number and a warehouse");
      }
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.item,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });
    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      this.newInfo = {
        itemNumber: this.state.data.itemNumber,
        whse:
          this.allData.wse.length > 0 ? this.allData.wse[0].toString() : null,
        setupDate: this.state.data.setupDate,
        changeDate: this.state.data.changeDate,
        vendOverrideId: this.state.data.vendOverrideId,
        nipoMaintDate: this.state.data.nipoMaintDate,
        nipoBaseCost: this.allData.nextPOCost
          ? this.allData.nextPOCost
          : this.state.data.nipoBaseCost,
        nipoCoreCost: this.state.data.nipoCoreCost,
        cubicFeet: this.allData.cubicFeet
          ? this.allData.cubicFeet
          : this.state.data.cubicFeet,
        unitsPerCase: this.allData.unitsPerCase
          ? this.allData.unitsPerCase
          : this.state.data.unitsPerCase,
        unitsPerTier: this.allData.casesPerTier
          ? this.allData.casesPerTier
          : this.state.data.unitsPerTier,
        tiersPerPallet: this.allData.tiersPerPallet
          ? this.allData.tiersPerPallet
          : this.state.data.tiersPerPallet,
        vendConvFactor: this.allData.factor
          ? this.allData.factor
          : this.state.data.vendConvFactor,
        vendConvAction: this.allData.action
          ? this.allData.action
          : this.state.data.vendConvAction,
        companyPoqMult: this.allData.companyPOQMultiple
          ? this.allData.companyPOQMultiple
          : this.state.data.companyPoqMult,
        originalVend: this.state.data.originalVend,
        vend: this.newInfo.vend
          ? this.newInfo.vend
          : this.allData.vendor
          ? this.allData.vendor
          : this.state.data.vend,
        hostVendorName: this.state.header[6].value,
        originalCoreReturnVendor: this.state.data.originalCoreReturnVendor,
        coreReturnVendor: this.newInfo.coreReturnVendor
          ? this.newInfo.coreReturnVendor
          : this.allData.coreReturn
          ? this.allData.coreReturn
          : this.state.data.coreReturnVendor,
        coreReturnVendorName: this.state.data.coreReturnVendorName,
        originalRecallVendor: this.state.data.originalRecallVendor,
        recallVendor: this.newInfo.recallVendor
          ? this.newInfo.recallVendor
          : this.allData.recall
          ? this.allData.recall
          : this.state.data.recallVendor,
        recallVendorName: this.state.data.recallVendorName,
        originalWarVendor: this.state.data.originalWarVendor,
        warrantyVendor: this.newInfo.warrantyVendor
          ? this.newInfo.warrantyVendor
          : this.allData.warranty
          ? this.allData.warranty
          : this.state.data.warrantyVendor,
        warrantyVendorName: this.state.data.warrantyVendorName,
        dcCasesPerTier: this.state.data.dcCasesPerTier,
        lineCode: this.state.data.lineCode,
        partNumber: this.state.data.partNumber,
        description: this.state.data.description,
        infPtag: this.state.data.infPtag,
        infDser: this.state.data.infDser,
        infDDI: this.state.data.infDDI,
        infPtagYear: this.state.data.infPtagYear
      };
      this.checkHotChanges();
    }
  };

  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  save = async () => {
    const uId = sessionStorage.getItem("uId");

    if (!this.state.isMultiRecordMode) {
      // Single-record mode
      if (!this.newInfo || !this.newInfo.itemNumber) {
        this.setErrorMessage("No valid data to save. Please modify a field first.");
        return;
      }
      const formattedWhses = this.state.lookup.whses.map(wse => {
        return wse.toString();
      });
      this.setNotification("Saving...", "#1e90ff", "hourglass_empty");

      var obj = {
        audit: {
          userId: uId
        },
        whses: formattedWhses,
        data: this.newInfo
      };

      updateVendorInformation(obj).then(res => {
        if (res.data.success) {
          this.setState({ data: "" });
          this.newInfo = {};
          this.lookup("Item was successfully updated");
          this.setSuccessMessage("Item was successfully updated");
          this.setState({ isSaveEnabled: false });
        } else {
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        console.error('Save error - payload:', JSON.stringify(obj, null, 2));
        console.error('Save error - response:', err.response?.data);
        this.setErrorMessage(this.formatHttpError(err));
      });
      return;
    }

    // Multi-record mode - BATCH UPDATE
    this.setNotification("Saving all records...", "#1e90ff", "hourglass_empty");

    // Paso 1: Filtrar solo registros válidos con cambios
    const recordsToSave = this.state.uploadedRecords.filter(record => {
      // Excluir registros fallidos
      if (record.isFailed) return false;

      // Excluir registros sin newInfo
      if (!record.newInfo || Object.keys(record.newInfo).length === 0) return false;

      // Solo incluir si tiene cambios reales
      const hasChanges = JSON.stringify(record.data).replace(/"/g, "") !==
                          JSON.stringify(record.newInfo).replace(/"/g, "");
      return hasChanges;
    });

    // Validar que haya registros para guardar
    if (recordsToSave.length === 0) {
      this.setWarningMessage("No changes to save");
      return;
    }

    // Validar límite del backend (máximo 100 registros)
    if (recordsToSave.length > 100) {
      this.setErrorMessage(`Cannot save more than 100 records at once. You have ${recordsToSave.length} records with changes.`);
      return;
    }

    // Paso 2: Construir payload en el formato del backend
    const batchPayload = {
      items: recordsToSave.map(record => ({
        audit: {
          userId: uId
        },
        whses: [record.dc],
        data: record.newInfo
      }))
    };

    // Paso 3: Enviar UNA SOLA llamada batch al backend
    try {
      const response = await batchUpdateVendorInformation(batchPayload);

      if (response.data.success) {
        // Check for partial failures
        const failedItems = response.data.failedItems || [];
        if (failedItems.length > 0) {
          const failed = failedItems.map(item => ({
            sku: item.itemNumber || item.sku || 'N/A',
            dc: item.whse || item.dc || 'N/A',
            errorMessage: item.error || item.message || 'Failed to save'
          }));
          this.setState({
            showBatchErrorModal: true,
            failedRecords: failed,
            failedRecordsTotalCount: recordsToSave.length,
            batchErrorSource: 'save'
          });
          this.setNotification();
          return;
        }

        const savedCount = recordsToSave.length;
        this.setSuccessMessage(
          `Successfully saved ${savedCount} record${savedCount !== 1 ? 's' : ''}`
        );

        const updatedRecords = this.state.uploadedRecords.map(record => {
          const wasSaved = recordsToSave.some(
            r => r.newInfo.itemNumber === record.newInfo?.itemNumber && r.dc === record.dc
          );
          if (wasSaved) {
            return { ...record, data: JSON.parse(JSON.stringify(record.newInfo)) };
          }
          return record;
        });

        this.setState({ uploadedRecords: updatedRecords, isSaveEnabled: false });

      } else {
        // Backend retornó success: false
        const failed = this.parseBatchErrorMessages(response.data.messages, recordsToSave);
        this.setState({
          showBatchErrorModal: true,
          failedRecords: failed,
          failedRecordsTotalCount: recordsToSave.length,
          batchErrorSource: 'save'
        });
        this.setNotification();
      }

    } catch (err) {
      console.error('Batch save error:', err.response?.status, err.response?.statusText, err.message);

      let errorSource;
      if (err.response && err.response.data?.messages) {
        errorSource = err.response.data.messages;
      } else {
        errorSource = this.formatHttpError(err);
      }

      const failed = this.parseBatchErrorMessages(errorSource, recordsToSave);
      this.setState({
        showBatchErrorModal: true,
        failedRecords: failed,
        failedRecordsTotalCount: recordsToSave.length,
        batchErrorSource: 'save'
      });
      this.setNotification();
    }
  };
  parseBatchErrorMessages = (messages, recordsToSave) => {
    const normalizeItem = (item) => {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object') return item.text || item.message || item.description || JSON.stringify(item);
      return String(item);
    };

    const msgStr = typeof messages === 'string'
      ? messages
      : Array.isArray(messages)
        ? messages.map(normalizeItem).join('; ')
        : String(messages || 'Failed to save records');

    // Format: "Item XXXX-DCYY: error msg; Item XXXX-DCZZ: error msg"
    const parts = msgStr.split(';').map(s => s.trim()).filter(Boolean);
    const itemPattern = /^Item\s+(\d+)\s*-\s*DC(\S+):\s*(.+)$/i;

    const parsed = [];
    const unmatched = [];

    parts.forEach(part => {
      const match = part.match(itemPattern);
      if (match) {
        parsed.push({ sku: match[1], dc: match[2], errorMessage: match[3].trim() });
      } else {
        unmatched.push(part);
      }
    });

    if (parsed.length > 0) {
      if (unmatched.length > 0) {
        parsed.push({ sku: 'N/A', dc: 'N/A', errorMessage: unmatched.join('; ') });
      }
      return parsed;
    }

    return recordsToSave.map(record => ({
      sku: record.newInfo.itemNumber || record.sku || 'N/A',
      dc: record.dc || 'N/A',
      errorMessage: msgStr
    }));
  };

  downloadTemplate = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/template/Item-Vendor Information by DC.xlsx`;
    link.download = 'Item-Vendor Information by DC.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  onGetExcelData = (excelData) => {
    if (!excelData || excelData.length === 0) {
      this.setErrorMessage("No data found in Excel file");
      return;
    }

    if (excelData.length > 100) {
      this.setErrorMessage(`Excel file contains ${excelData.length} records. Maximum allowed is 100.`);
      return;
    }

    clearTimeout(this.dcReminderTimer);

    this.setState({
      isMultiRecordMode: true,
      totalToProcess: excelData.length,
      currentProcessing: 0,
      isLoadingRecords: true
    });

    this.processExcelRows(excelData);
  };

  errorHeaderExcel = () => {
    this.setErrorMessage("File does not contain required data, please check template.");
  };

  exitMultiRecordMode = () => {
    this.setState({
      isMultiRecordMode: false,
      uploadedRecords: [],
      currentProcessing: 0,
      totalToProcess: 0,
      isSaveEnabled: false,
      isLoadingRecords: false
    });
  };

  closeBatchErrorModal = () => {
    const isImportError = this.state.batchErrorSource === 'import';

    this.setState({
      showBatchErrorModal: false,
      failedRecords: [],
      failedRecordsTotalCount: 0,
      batchErrorSource: null,
      currentProcessing: 0,
      totalToProcess: 0,
      isSaveEnabled: false,
      isLoadingRecords: false,
      ...(isImportError ? { isMultiRecordMode: false, uploadedRecords: [] } : {})
    });
  };

  processExcelRows = async (excelData) => {
    const uploadedRecords = new Array(excelData.length).fill(null);
    const validRows = [];

    for (let i = 0; i < excelData.length; i++) {
      const row = excelData[i];
      const excelRow = i + 2;
      const missingFields = [];
      if (!row.sku || String(row.sku).trim() === '' || isNaN(parseInt(row.sku, 10))) missingFields.push('SKU');
      if (!row.dc || String(row.dc).trim() === '') missingFields.push('DC');
      if (!row.vendor || String(row.vendor).trim() === '') missingFields.push('VENDOR');

      if (missingFields.length > 0) {
        uploadedRecords[i] = {
          sku: row.sku || 'N/A',
          dc: row.dc || 'N/A',
          excelRow,
          isLoaded: false,
          isFailed: true,
          createdAt: Date.now(),
          errorMessage: `Missing or invalid fields: ${missingFields.join(', ')}`
        };
      } else {
        validRows.push({ row, excelRow, index: i });
      }
    }

    if (validRows.length > 0) {
      this.setNotification(
        `Loading vendor information for ${validRows.length} items...`,
        "#1e90ff",
        "hourglass_empty"
      );

      const batchPayload = {
        items: validRows.map(({ row }) => ({
          itemNumber: parseInt(row.sku, 10),
          whse: String(row.dc)
        }))
      };

      try {
        const response = await batchReadVendorInformation(batchPayload);

        if (response && response.data && response.data.results) {
          const results = response.data.results;
          for (let j = 0; j < validRows.length; j++) {
            const { row, excelRow, index } = validRows[j];
            const result = results[j];

            if (result && result.success && result.data) {
              uploadedRecords[index] = this.createRecordFromResponse(result.data, row, excelRow);
            } else {
              let itemError;
              if (!result) {
                itemError = `No response received from server (Excel row ${excelRow})`;
              } else if (result.errorMessage) {
                itemError = result.errorMessage;
              } else {
                itemError = `Could not load vendor information (Excel row ${excelRow})`;
              }
              uploadedRecords[index] = {
                sku: row.sku,
                dc: row.dc,
                excelRow,
                isLoaded: false,
                isFailed: true,
                createdAt: Date.now(),
                errorMessage: itemError
              };
            }
          }
        } else {
          for (const { row, excelRow, index } of validRows) {
            uploadedRecords[index] = {
              sku: row.sku,
              dc: row.dc,
              excelRow,
              isLoaded: false,
              isFailed: true,
              createdAt: Date.now(),
              errorMessage: `Server returned an invalid response (Excel row ${excelRow})`
            };
          }
        }
      } catch (err) {
        const errorMessage = this.formatHttpError(err);
        for (const { row, excelRow, index } of validRows) {
          uploadedRecords[index] = {
            sku: row.sku,
            dc: row.dc,
            excelRow,
            isLoaded: false,
            isFailed: true,
            createdAt: Date.now(),
            errorMessage
          };
        }
      }
    }

    this.setState({
      currentProcessing: excelData.length,
      uploadedRecords: [...uploadedRecords]
    });

    const failed = uploadedRecords.filter(r => r.isFailed);
    const successCount = uploadedRecords.filter(r => !r.isFailed).length;

    if (failed.length > 0) {
      this.setState({
        showBatchErrorModal: true,
        failedRecords: failed,
        failedRecordsTotalCount: excelData.length,
        batchErrorSource: 'import',
        currentProcessing: 0,
        totalToProcess: 0,
        isLoadingRecords: false
      });
      this.setNotification();
      return;
    }

    this.setSuccessMessage(`Loaded ${successCount} of ${excelData.length} records`);
    this.setState({
      currentProcessing: 0,
      totalToProcess: 0,
      uploadedRecords,
      isLoadingRecords: false
    }, () => {
      this.checkMultiRecordChanges();
    });
  };

  createRecordFromResponse = (apiData, row, excelRowNumber) => {
    // Apply Excel values to override API data
    const itemValue = this.numberToZeroPadded(apiData.itemNumber, 9);
    const vendorValue = row.vendor || apiData.vend;
    const vendorNameValue = row.name || apiData.hostVendorName;

    const header = [
      {
        label: "Item",
        value: itemValue,
        injectedValue: itemValue,
        name: "item"
      },
      {
        label: "Description",
        value: apiData.description,
        injectedValue: apiData.description,
        name: "description"
      },
      {
        label: "Line",
        value: apiData.lineCode,
        injectedValue: apiData.lineCode,
        name: "line"
      },
      {
        label: "Part",
        value: apiData.partNumber,
        injectedValue: apiData.partNumber,
        name: "part"
      },
      {
        label: "Warehouses",
        value: [row.dc],
        name: "wse"
      },
      {
        label: "Vendor",
        value: vendorValue,
        injectedValue: vendorValue,
        name: "vendor"
      },
      {
        label: "Vendor Name",
        value: vendorNameValue,
        injectedValue: vendorNameValue,
        name: "vendorName"
      },
      {
        label: "Core Return",
        value: apiData.coreReturnVendor,
        injectedValue: apiData.coreReturnVendor,
        name: "coreReturn"
      },
      {
        label: "Vendor Name",
        value: apiData.coreReturnVendorName,
        injectedValue: apiData.coreReturnVendorName,
        name: "vendorName2"
      },
      {
        label: "Recall",
        value: apiData.recallVendor,
        injectedValue: apiData.recallVendor,
        name: "recall"
      },
      {
        label: "Vendor Name",
        value: apiData.recallVendorName,
        injectedValue: apiData.recallVendorName,
        name: "vendorName3"
      },
      {
        label: "Warranty",
        value: apiData.warrantyVendor,
        injectedValue: apiData.warrantyVendor,
        name: "warranty"
      },
      {
        label: "Vendor Name",
        value: apiData.warrantyVendorName,
        injectedValue: apiData.warrantyVendorName,
        name: "vendorName4"
      },
      {
        label: "Next PO Cost",
        value: apiData.nipoBaseCost,
        injectedValue: apiData.nipoBaseCost,
        name: "nextPOCost"
      },
      {
        label: "Core",
        value: apiData.nipoCoreCost,
        injectedValue: apiData.nipoCoreCost,
        name: "core"
      },
      {
        label: "NIPO Maintenance Date",
        value: apiData.nipoMaintDate,
        injectedValue: apiData.nipoMaintDate,
        name: "NPOMaintenanceDate"
      },
      {
        label: "Setup Date",
        value: apiData.setupDate,
        injectedValue: apiData.setupDate,
        name: "setupDate"
      },
      {
        label: "Change Date",
        value: apiData.changeDate,
        injectedValue: apiData.changeDate,
        name: "changeDate"
      }
    ];

    const casesPerTierValue = row.casesPerTier || apiData.unitsPerTier;
    const unitsPerCaseValue = row.unitsPerCase || apiData.unitsPerCase;
    const tiersPerPalletValue = row.tiersPerPallet || apiData.tiersPerPallet;
    const poqValue = row.poq || apiData.companyPoqMult;

    const cards = [
      {
        Dimensions: [
          {
            label: "Cubic Feet",
            value: apiData.cubicFeet,
            injectedValue: apiData.cubicFeet,
            name: "cubicFeet"
          },
          {
            label: "Cases Per Tier",
            value: casesPerTierValue,
            injectedValue: casesPerTierValue,
            name: "casesPerTier"
          },
          {
            label: "Units Per Case",
            value: unitsPerCaseValue,
            injectedValue: unitsPerCaseValue,
            name: "unitsPerCase"
          },
          {
            label: "Tiers Per Pallet",
            value: tiersPerPalletValue,
            injectedValue: tiersPerPalletValue,
            name: "tiersPerPallet"
          }
        ]
      },
      {
        "INFOREM Info": [
          {
            label: "Profile ID",
            value: apiData.infPtag,
            injectedValue: apiData.infPtag,
            name: "profileID"
          },
          {
            label: "DSER",
            value: apiData.infDser,
            injectedValue: apiData.infDser,
            name: "DSER"
          },
          {
            label: "Profile Year",
            value: apiData.infPtagYear,
            injectedValue: apiData.infPtagYear,
            name: "profileYear"
          },
          {
            label: "Init DESEAS Demand",
            value: apiData.infDDI,
            injectedValue: apiData.infDDI,
            name: "initDESEASDemand"
          }
        ]
      },
      {
        "Vendor Conversion": [
          {
            label: "Factor",
            value: apiData.vendConvFactor,
            injectedValue: apiData.vendConvFactor,
            name: "factor"
          },
          {
            label: "Action (* OR /)",
            value: apiData.vendConvAction,
            injectedValue: apiData.vendConvAction,
            name: "action"
          },
          {
            label: "Company POQ Multiple",
            value: poqValue,
            injectedValue: poqValue,
            name: "companyPOQMultiple"
          }
        ]
      }
    ];

    // Initialize newInfo with Excel values already applied
    const newInfo = {
      itemNumber: apiData.itemNumber,
      whse: row.dc,
      setupDate: apiData.setupDate,
      changeDate: apiData.changeDate,
      vendOverrideId: apiData.vendOverrideId,
      nipoMaintDate: apiData.nipoMaintDate,
      nipoBaseCost: apiData.nipoBaseCost,
      nipoCoreCost: apiData.nipoCoreCost,
      cubicFeet: apiData.cubicFeet,
      unitsPerCase: row.unitsPerCase || apiData.unitsPerCase,
      unitsPerTier: row.casesPerTier || apiData.unitsPerTier,
      tiersPerPallet: row.tiersPerPallet || apiData.tiersPerPallet,
      vendConvFactor: apiData.vendConvFactor,
      vendConvAction: apiData.vendConvAction,
      companyPoqMult: row.poq || apiData.companyPoqMult,
      originalVend: apiData.originalVend,
      vend: row.vendor || apiData.vend,
      hostVendorName: row.name || apiData.hostVendorName,
      originalCoreReturnVendor: apiData.originalCoreReturnVendor,
      coreReturnVendor: apiData.coreReturnVendor,
      coreReturnVendorName: apiData.coreReturnVendorName,
      originalRecallVendor: apiData.originalRecallVendor,
      recallVendor: apiData.recallVendor,
      recallVendorName: apiData.recallVendorName,
      originalWarVendor: apiData.originalWarVendor,
      warrantyVendor: apiData.warrantyVendor,
      warrantyVendorName: apiData.warrantyVendorName,
      dcCasesPerTier: apiData.dcCasesPerTier,
      lineCode: apiData.lineCode,
      partNumber: apiData.partNumber,
      description: apiData.description,
      infPtag: apiData.infPtag,
      infDser: apiData.infDser,
      infDDI: apiData.infDDI,
      infPtagYear: apiData.infPtagYear
    };

    return {
      sku: row.sku,
      dc: row.dc,
      excelRow: excelRowNumber,
      isLoaded: true,
      isFailed: false,
      createdAt: Date.now(),
      data: apiData,
      header,
      cards,
      newInfo,
      allData: {
        wse: [row.dc],
        vendor: row.vendor,
        unitsPerCase: row.unitsPerCase,
        casesPerTier: row.casesPerTier,
        tiersPerPallet: row.tiersPerPallet,
        companyPOQMultiple: row.poq
      }
    };
  };

  handleRecordChange = (recordIndex, section, changes) => {
    const updatedRecords = [...this.state.uploadedRecords];
    const record = updatedRecords[recordIndex];

    Object.keys(changes[Object.keys(changes)]).forEach(
      val => (record.allData[val] = changes[Object.keys(changes)][val])
    );

    record.newInfo = {
      itemNumber: record.data.itemNumber,
      whse: record.dc,
      setupDate: record.data.setupDate,
      changeDate: record.data.changeDate,
      vendOverrideId: record.data.vendOverrideId,
      nipoMaintDate: record.data.nipoMaintDate,
      nipoBaseCost: record.allData.nextPOCost ? record.allData.nextPOCost : record.data.nipoBaseCost,
      nipoCoreCost: record.data.nipoCoreCost,
      cubicFeet: record.allData.cubicFeet ? record.allData.cubicFeet : record.data.cubicFeet,
      unitsPerCase: record.allData.unitsPerCase ? record.allData.unitsPerCase : record.data.unitsPerCase,
      unitsPerTier: record.allData.casesPerTier ? record.allData.casesPerTier : record.data.unitsPerTier,
      tiersPerPallet: record.allData.tiersPerPallet ? record.allData.tiersPerPallet : record.data.tiersPerPallet,
      vendConvFactor: record.allData.factor ? record.allData.factor : record.data.vendConvFactor,
      vendConvAction: record.allData.action ? record.allData.action : record.data.vendConvAction,
      companyPoqMult: record.allData.companyPOQMultiple ? record.allData.companyPOQMultiple : record.data.companyPoqMult,
      originalVend: record.data.originalVend,
      vend: record.newInfo.vend ? record.newInfo.vend : record.allData.vendor ? record.allData.vendor : record.data.vend,
      hostVendorName: record.header[6].value,
      originalCoreReturnVendor: record.data.originalCoreReturnVendor,
      coreReturnVendor: record.newInfo.coreReturnVendor ? record.newInfo.coreReturnVendor : record.allData.coreReturn ? record.allData.coreReturn : record.data.coreReturnVendor,
      coreReturnVendorName: record.data.coreReturnVendorName,
      originalRecallVendor: record.data.originalRecallVendor,
      recallVendor: record.newInfo.recallVendor ? record.newInfo.recallVendor : record.allData.recall ? record.allData.recall : record.data.recallVendor,
      recallVendorName: record.data.recallVendorName,
      originalWarVendor: record.data.originalWarVendor,
      warrantyVendor: record.newInfo.warrantyVendor ? record.newInfo.warrantyVendor : record.allData.warranty ? record.allData.warranty : record.data.warrantyVendor,
      warrantyVendorName: record.data.warrantyVendorName,
      dcCasesPerTier: record.data.dcCasesPerTier,
      lineCode: record.data.lineCode,
      partNumber: record.data.partNumber,
      description: record.data.description,
      infPtag: record.data.infPtag,
      infDser: record.data.infDser,
      infDDI: record.data.infDDI,
      infPtagYear: record.data.infPtagYear
    };

    this.setState({ uploadedRecords: updatedRecords });
    this.checkMultiRecordChanges();
  };

  checkMultiRecordChanges = () => {
    const hasChanges = this.state.uploadedRecords.some(record => {
      // Skip failed records or records without data
      if (record.isFailed || !record.data || !record.newInfo) {
        return false;
      }
      return JSON.stringify(record.data).replace(/"/g, "") !== JSON.stringify(record.newInfo).replace(/"/g, "");
    });

    this.setState({ isSaveEnabled: hasChanges });
  };

  handleMultiRecordVendorCheck = (recordIndex, vendorType, newVendorId) => {
    const record = this.state.uploadedRecords[recordIndex];

    if (!record || !record.data) return;

    var vdrType;
    var vdrTag;
    var stateName;
    var stateId;
    var tagName;

    switch (vendorType) {
      case "vendor":
        vdrType = "HV";
        vdrTag = "vendorName";
        stateName = "hostVendorName";
        stateId = "vend";
        tagName = "Vendor";
        break;
      case "coreReturn":
        vdrType = "CV";
        vdrTag = "vendorName2";
        stateName = "coreReturnVendorName";
        stateId = "coreReturnVendor";
        tagName = "Core Return";
        break;
      case "warranty":
        vdrType = "WV";
        vdrTag = "vendorName4";
        stateName = "warrantyVendorName";
        stateId = "warrantyVendor";
        tagName = "Warranty";
        break;
      case "recall":
        vdrType = "RV";
        vdrTag = "vendorName3";
        stateName = "recallVendorName";
        stateId = "recallVendor";
        tagName = "Recall";
        break;
      default:
        break;
    }

    newVendorId = newVendorId.replace(/\s/gi, "");
    var _newVendorId = newVendorId.length > 0 ? newVendorId : record.data[stateId];

    checkChgVendorAvailability(record.data[stateId], _newVendorId, record.dc, vendorType)
      .then(res => {
        const updatedRecords = [...this.state.uploadedRecords];
        const updatedRecord = updatedRecords[recordIndex];

        if (res.data.success === false) {
          this.modifyVendorForRecord(updatedRecord, vendorType, _newVendorId, vdrTag, "Invalid Vendor For This Warehouse", false, tagName, stateId);
          this.setErrorMessage("Invalid Vendor For This Warehouse");
        } else {
          const newVendorName = res.data.success !== null ? res.data.vendorName : record.data[stateName];
          this.modifyVendorForRecord(updatedRecord, vendorType, _newVendorId, vdrTag, newVendorName, true, tagName, stateId);
        }

        this.setState({ uploadedRecords: updatedRecords });
        this.checkMultiRecordChanges();
      })
      .catch(err => {
        this.setErrorMessage(this.formatHttpError(err));
      });
  };

  modifyVendorForRecord = (record, id, whse, id2, whseName, isValid, tagName, stateId) => {
    for (let i = 0; i < record.header.length; i++) {
      if (record.header[i].name === id) {
        record.header[i].injectedValue = whse;
        record.header[i].label = (
          <div className="with-tooltip">
            <i
              className="material-icons"
              style={isValid ? { color: "green" } : { color: "red" }}
            >
              {isValid ? "check" : "cancel"}
            </i>
            <Tooltip
              msg={isValid ? "Valid Vendor For This Warehouse" : whseName}
            />
            {tagName}
          </div>
        );
      }
      if (record.header[i].name === id2) {
        record.header[i].injectedValue = whseName;
      }
    }
    record.newInfo[stateId] = whse;
  };

  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };
  checkVendor = (vendorType, newVendorId) => {
    if (this.state.data) {
      var vdrType;
      var vdrTag;
      var stateName;
      var stateId;
      var originalVendorId;
      var tagName;
      switch (vendorType) {
        case "vendor":
          vdrType = "HV";
          vdrTag = "vendorName";
          stateName = "hostVendorName";
          stateId = "vend";
          tagName = "Vendor";
          break;
        case "coreReturn":
          vdrType = "CV";
          vdrTag = "vendorName2";
          stateName = "coreReturnVendorName";
          stateId = "coreReturnVendor";
          tagName = "Core Return";
          break;
        case "warranty":
          vdrType = "WV";
          vdrTag = "vendorName4";
          stateName = "warrantyVendorName";
          stateId = "warrantyVendor";
          tagName = "Warranty";
          break;
        case "recall":
          vdrType = "RV";
          vdrTag = "vendorName3";
          stateName = "recallVendorName";
          stateId = "recallVendor";
          tagName = "Recall";
          break;
        default:
          break;
      }

      /*
    originalVendorId,
    newVendorId,
    whse,
    vendorType
    */
      newVendorId = newVendorId.replace(/\s/gi, "");
      var _newVendorId =
        newVendorId.length > 0 ? newVendorId : this.state.data[stateId];

      checkChgVendorAvailability(
        this.state.data[stateId],
        _newVendorId,
        this.state.data.whse,
        vendorType
      ).then(res => {
        if (res.data.success === false) {
          this.modifyVendor(
            vendorType,
            _newVendorId,
            vdrTag,
            "Invalid Vendor For This Warehouse",
            false,
            tagName,
            stateId
          );
          this.setErrorMessage("Invalid Vendor For This Warehouse");
        } else {
          const newVendorName =
            res.data.success !== null
              ? res.data.vendorName
              : this.state.data[stateName];
          this.modifyVendor(
            vendorType,
            _newVendorId,
            vdrTag,
            newVendorName,
            true,
            tagName,
            stateId
          );
          this.setState({
            modalButton1ActionParams: [_newVendorId, newVendorName]
          });
          if (this.state.data[stateId] !== _newVendorId) {
            this.handeOpenModal(
              "choice",
              `${newVendorName} (${_newVendorId}), is valid for this warehouse, Apply for all vendors?`,
              "YES",
              "NO",
              false
            );
          }
        }
      }).catch(err => {
        this.setErrorMessage(this.formatHttpError(err));
      });
      this.checkHotChanges();
    }
  };
  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  handeOpenModal = (param, param2, param3, param4, param5) => {
    this.setState({ modalOpen: true });

    // if (this.state.data) {
    this.setState({ action: param });
    this.setState({ modalMsg: param2 });
    this.setState({ modalButtonText: param3 });
    this.setState({ modalButtonText2: param4 });
    if (param === "success" || param === "fail") {
      this.setState({ onlyClose: true });
    } else {
      this.setState({ onlyClose: false });
    }
    this.setState({ modalReturn: param5 });
    // }
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  modifyAllVendors = (x, y) => {
    this.modifyVendor("vendor", x, "vendorName", y, true, "Vendor", "vend");
    this.modifyVendor(
      "coreReturn",
      x,
      "vendorName2",
      y,
      true,
      "Core Return",
      "coreReturnVendor"
    );
    this.modifyVendor(
      "recall",
      x,
      "vendorName3",
      y,
      true,
      "Recall",
      "recallVendor"
    );
    this.modifyVendor(
      "warranty",
      x,
      "vendorName4",
      y,
      true,
      "Warranty",
      "warrantyVendor"
    );
    this.closeModal();
    // this.mockValues2(
    //   ["vendor", "coreReturn", "recall", "warranty"],
    //   5,
    //   ["vendorName", "vendorName2", "vendorName3", "vendorName4"],
    //   "Name"
    // );

    return null;
  };
  componentDidUpdate() {}
  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
    clearTimeout(this.dcReminderTimer);
  }

  handleOpenModal = () => {
    this.state.modal2Open
      ? this.setState({ modal2Open: false })
      : this.setState({ modal2Open: true });
  };
  closeModal2 = e => {
    this.setState({ modal2Open: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Item-Vendor Information By DC
        </h3>
        {!this.state.isMultiRecordMode ? (
          <>
            <HeaderLayout
              headerData={this.state.header}
              setHeaderInfo={this.getHeaderInfo}
              lookup={this.lookup}
              checkVendor={this.checkVendor}
              setErrorMessage={this.setErrorMessage}
              setSuccessMessage={this.setSuccessMessage}
              warehouseList={this.state.warehouseList}
            />
            {this.state.cards && (
              <CardsLayout
                cardsData={this.state.cards}
                setCardsInfo={this.getCardsInfo}
              />
            )}
          </>
        ) : (
          <MultiRecordLayout
            records={this.state.uploadedRecords}
            onRecordChange={this.handleRecordChange}
            onCheckVendor={this.handleMultiRecordVendorCheck}
            setErrorMessage={this.setErrorMessage}
            setSuccessMessage={this.setSuccessMessage}
            isLoadingRecords={this.state.isLoadingRecords}
            warehouseList={this.state.warehouseList}
          />
        )}
        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
              style={{ margin: 0 }}
            >
              Close
            </Button>
            {this.state.isMultiRecordMode && (
              <Button
                bsStyle="info"
                className="btn-sm"
                disabled={false}
                onClick={this.exitMultiRecordMode}
                style={{ margin: 0 }}
              >
                Exit Multi-Record Mode
              </Button>
            )}
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={this.downloadTemplate}
              style={{ margin: 0 }}
            >
              Download Template
            </Button>
            {!this.state.isMultiRecordMode && (
              <UploadButtonVendorInfo
                onGetExcelData={this.onGetExcelData}
                openNotification={(show) => this.setState({ isNotificationOpened: show })}
                onUploadClick={() => { clearTimeout(this.dcReminderTimer); this.setNotification(); }}
                errorHeader={this.errorHeaderExcel}
              />
            )}
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
              style={{ margin: 0 }}
            >
              Save{this.state.isMultiRecordMode ? ' All' : ''}
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={this.state.action}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button1: e =>
              this.modifyAllVendors(
                this.state.modalButton1ActionParams[0],
                this.state.modalButton1ActionParams[1]
              ),
            button2: e => this.closeModal(e)
          }}
          hasOnlyClose={this.state.onlyClose}
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          icon={this.state.modalIcon}
          active={true}
          buttonText={this.state.modalButtonText}
          buttonText2={this.state.modalButtonText2}
          noReturn={!this.state.modalReturn}
        />
        <StatusModal
          modal={this.state.modal2Open === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal2(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
        <BatchErrorModal
          isOpen={this.state.showBatchErrorModal}
          failedRecords={this.state.failedRecords}
          totalRecords={this.state.failedRecordsTotalCount}
          onClose={this.closeBatchErrorModal}
        />
      </div>
    );
  }
}
export default ManageItemVendorInformationByDc;
